import api from "../utils/API";

// Base URL for your API
export const territoryService = {
  fetchList: async (payload) => {
    try {
      const response = await api.get("/admin/territory", { params: payload });
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },
  createTerritory: async (payload) => {
    try {
      const response = await api.post("/admin/territory", payload);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  updateTerritory: async (id, payload) => {
    try {
      const response = await api.put(`/admin/territory/${id}`, payload);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  deleteTerritory: async (id) => {
    try {
      const response = await api.delete(`/admin/territory/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  fetchTerritoryById: async (id) => {
    try {
      const response = await api.get(`/admin/territory/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  getTerritoryOptions: async () => {
    try {
      const response = await api.get("/admin/territory/all");
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  assignSalesRep: async (id, payload) => {
    try {
      const response = await api.post(`/admin/territory/${id}/sales-rep`, payload);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
};
